
export class ContactDetailModel {
  private address!: string;
  private homeNumber!: number;
  private mobileNumber!: number;
  private personalEmailAddress!: string;
  private pias_rep_code!: string;




  constructor() { }
  getPiasrepCode(): string {
    return this.pias_rep_code;
  }
  setPiasrepCode(pias_rep_code: string) {
    this.pias_rep_code = pias_rep_code;
  }

  getAddress(): string {
    return this.address;
  }
  setAddress(address: string) {
    this.address = address;
  }

  getHomeNumber(): number {
    return this.homeNumber;
  }
  setHomeNumber(homeNumber: number) {
    this.homeNumber = homeNumber;
  }

  getMobileNumber(): number {
    return this.mobileNumber;
  }
  setMobileNumber(mobileNumber: number) {
    this.mobileNumber = mobileNumber;
  }

  getPersonalEmailAddress(): string {
    return this.personalEmailAddress;
  }
  setPersonalEmailAddress(personalEmailAddress: string) {
    this.personalEmailAddress = personalEmailAddress;
  }

  toString() {
    return JSON.stringify({
      address: this.getAddress(),
      homeNumber: this.getHomeNumber(),
      mobileNumber: this.getMobileNumber(),
      personalEmailAddress: this.getPersonalEmailAddress(),
      pias_rep_code: this.getPiasrepCode()
    });
  }

}


